// extracted by mini-css-extract-plugin
export default {"copy":"CopyControl_copy__n0p2l","copyArea":"CopyControl_copyArea__FTAcz"};